import * as d3 from 'd3'
export default {
  methods: {

    draw_Scrollbar() {

      this.canvasScroll = this.svg
      .append('g')
      .attr('id', `CANVAS_SCROLL_${this.localId}`)
      .attr('transform', `translate(${this.header.x + this.header.width + 2}, ${this.header.y + this.header.height})`)

      this.canvasScroll
      .append('rect')
      .attr('x', this.scroll.bar.padding).attr('y', 0)
      .attr('width', this.scroll.bar.width).attr('height', this.scroll.viewbox.height)
      .attr('fill', '#E0E0DF').attr('opacity', .3)

      this.canvasScroll
      .append('rect')
      .attr('id', `SCROLL_BAR_${this.localId}`)
      .attr('x', this.scroll.bar.padding).attr('y', 0)
      .attr('width', this.scroll.bar.width).attr('height', this.scroll.bar.size)
      .attr('fill', this.scroll.bar.color).attr('opacity', this.scroll.bar.opacity)
      .call(
        d3.drag()
        .on('drag', (event) => this.dragging(event))
      )
    },


    dragging(event) {
      console.log(this.scroll.bar)
      let bar = this.scroll.bar
      let viewbox = this.scroll.viewbox
      let content = this.scroll.content
      let wheel = this.scroll.wheel
      
      bar.y = bar.y + event.dy

      if(bar.y < 0) bar.y = 0
      if((bar.y + bar.size) > viewbox.height) bar.y = bar.space
     
      d3.select(`#SCROLL_BAR_${this.localId}`).attr('y', bar.y)

      let bar_ratio = bar.y / bar.space
      content.y = viewbox.space * bar_ratio
      d3.select(`#CANVAS_CONTENTS_${this.localId}`).attr('transform', `translate(${this.header.x}, ${-content.y + this.header.y + this.header.height})`)
      wheel.count = -parseInt(content.y / 30)
      // console.log(wheel.count, 'contents:' + content.y, ' bar: ' + bar.y) // ## console.log
    },
    

    wheeling() {
      let bar = this.scroll.bar
      let viewbox = this.scroll.viewbox
      let content = this.scroll.content
      let wheel = this.scroll.wheel

      var direction = d3.event.wheelDelta < 0 ? 'down' : 'up'
      if (direction == 'down') wheel.count--; else wheel.count++

      if(wheel.count < -wheel.step) wheel.count = -wheel.step
      if(wheel.count > 0) wheel.count = 0

      content.y = wheel.count * (wheel.ratio * viewbox.space)
      if(content.y < -viewbox.space) content.y = -bar.space
      if(content.y > 0) content.y = 0

      d3.select(`#CANVAS_CONTENTS_${this.localId}`).attr('transform', `translate(${this.header.x}, ${content.y + this.header.y + this.header.height})`)

      bar.y = -wheel.count * bar.ratio
      if(bar.y < 0) bar.y = 0
      if((bar.y + bar.size) > viewbox.height) bar.y = viewbox.space

      d3.select(`#SCROLL_BAR_${this.localId}`).attr('y', bar.y)
      // console.log(direction, wheel.count, 'contents:' + content.y, ' bar: ' + bar.y) // ## console.log
    },


  }
}